<template>
	<div id="visitRecord">
		<div class="title-top bg-f mb-5 topDiv">
			 <div>拜访记录</div>
			 <div>
					<el-button type="info" size="small" @click="$router.push(basePath + '/reminderList')">拜访提醒</el-button>
			 </div>
		</div>
		<div class="main bg-f pb-50 pl-30 pr-30">
			<el-tabs v-model="active">
        <el-tab-pane label="拜访记录" name="1"></el-tab-pane>
        <el-tab-pane label="拜访统计" name="2"></el-tab-pane>
      </el-tabs>
			<visitRecordList v-if="active=='1'"/>
			<visitStatistics v-if="active=='2'"/>
		</div>
	</div>
</template>

<script>
	import { axiosApi, basePath } from '~/api/api'
	import visitRecordList from "./visitRecordList.vue";
	import visitStatistics from "./visitStatistics.vue";
	export default {
		components: {visitRecordList,visitStatistics},
		data() {
			return {
				active:'1',
			}
		},
		methods: {
			
		},
	}
</script>

<style lang="less">
	#visitRecord {
		padding-left: 15px;
		padding-bottom: 50px;
		.el-tabs__header{
			padding-left: 0;
		}
		.topDiv{
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding-right: 20px;
			box-sizing: border-box;
		}
	}
</style>